import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class Obelisk extends UnitType {
    readonly id = "obelisk";
    readonly displayName = "Obelisk";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.netherworld; }
    playerCanControl() { return false; }
    canEnter(ctx: PlaceContext) { return ctx.game.overworld.get(ctx.x, ctx.y)?.unitId !== "pentagram" && this.inTile(ctx, ["land"], ctx.game.netherworld); }
    description() { return "Large influence range."; }
    img(ctx: UnitContext) { return "obelisk_" + ctx.faction; }
    maxCooldown() { return 0; }
    cost() { return { souls: 0, blood: 400, runes: 6 }; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "obelisk"); }
    influenceRange(): number { return 3.5; }
}
